import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

export const getJobBeingEdited = createSelector(
  (state: RootState) => state.jobs.jobs,
  (state: RootState) => state.jobs.draftJob,
  (jobs, draftJob) =>
    draftJob?.jobBeingEditedId != null ? jobs.find((job) => job.id === draftJob?.jobBeingEditedId)! : null,
);
